import React, {Fragment} from 'react'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import styled, {css} from 'react-emotion'
import {compose, withProps, lifecycle, withState, withHandlers} from 'recompose'
import shield from '../../../../../static/images/security-on.svg'
import * as path from '../../../common/path'
import {Currency, NormalSlider} from '../../../components/index'
import {withAnswers} from '../../../enhances'
import defaultLogo from '../../../../../static/images/default-company-logo.png'
import {toCurrency} from '../../../core/helper'
import TooltipBudgetModal from './TooltipBudgetModal'
import itaxApi from '../../../common/api'
import numeral from 'numeral'
import {spidusStore} from '../../../core/spidus'

const Layout = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 40px;
`
export const GoBack = styled.div`
  width: 100%;
  max-width: 600px;
  display: flex;
  align-items: center;
  padding: 0px 26px;
  color: #7f7f7f;
  font-size: 16px;
  > svg {
    margin-right: 12px;
  }
`
export const SelectionSliderBar = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 30px;
  margin-bottom: 40px;
  max-width: 220px;
`
export const InsuranceType = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  > svg {
    color: #265fa7;
    font-size: 30px;
  }
  margin-bottom: 34px;
`
export const TopicType = styled.div`
  font-weight: 700;
  font-size: 20px;
  color: #265fa7;
  text-align: center;
`
export const DescriptionType = styled.div`
  font-size: 12px;
  color: #265fa7;
  text-align: center;
`
export const Budget = styled.div`
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  color: #252525;
  margin-bottom: 13px;
  white-space: nowrap;
  > svg {
    margin-left: 14px;
    color: #c1c1c1;
  }
`
export const CustomCurrency = styled(Currency)`
  > div:first-child {
    display: none;
  }
  > div:last-child {
    > input {
      text-align: center;
      color: #333333;
      font-size: 20px;
      font-weight: 700;
    }
  }
  margin-bottom: 20px;
  padding: 0 5px;
`
const Card = styled.div`
  width: 100%;
  max-width: 300px;
  margin: 10px;
  min-height: 400px;
  border: 1px solid ${props => (props.suggest ? '#9FD134' : '#C1C1C1')};
  border-radius: 5px;
  padding: 30px 15px;
  margin-top: ${props => props.suggest && '0'};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  color: #333333;
  cursor: pointer;
  font-family: 'Prompt', 'Roboto', sans-serif;
`
const Top = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
const Mid = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin: 40px 0;
`
const Footer = styled.div``
const Row = styled.div`
  display: flex;
  line-height: 2;
  justify-content: space-between;
`
const Label = styled.div`
  font-size: 12px;
  display: flex;
  align-items: center;
`
const Value = styled.div`
  font-family: 'Prompt', 'Roboto', sans-serif;
`
const InsuranceValue = styled.div`
  font-size: 42px;
  color: #265fa7;
  font-weight: 700;
  font-family: 'Prompt', 'Roboto', sans-serif;
`
const SmallText = styled.div`
  font-size: 14px;
  color: #6a94cb;
  font-family: 'Prompt', 'Roboto', sans-serif;
`
const InsuranceText = styled.div`
  color: #6a94cb;
  font-size: 16px;
  font-weight: 700;
`
const Name = styled.div`
  font-size: 16px;
  font-weight: 700;
  font-family: 'Prompt', 'Roboto', sans-serif;
`
const Symbol = styled.div`
  font-size: 12px;
`
const Img = styled.img`
  width: 30px;
  height: 30px;
  border-radius: 5px;
`
const Shield = styled.img`
  width: 50px;
  height: 50px;
`
const WrapText = styled.div`
  padding: 0 10px;
  flex: 1;
`
const MoneySymbol = styled.span`
  font-size: 20px;
  font-weight: 700;
  color: #265fa7;
  font-family: 'Prompt', 'Roboto', sans-serif;
`
const Icon = styled(FontAwesomeIcon)`
  margin-bottom: 3px;
  margin-right: 5px;
`
const Wrap = styled.div`
  position: relative;
`
const Point = styled.div`
  width: 50px;
  height: 50px;
  position: absolute;
  font-family: 'Prompt', 'Roboto', sans-serif;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-weight: 600;
  font-size: 20px;
  left: 0;
`
const SuggestSign = styled.div`
  border: 1px solid #9fd134;
  border-bottom: 0;
  padding: 5px 10px;
  background: #9fd134;
  border-radius: 5px 5px 0 0;
  color: white;
  width: 73px;
  margin: 0 35px;
  text-align: center;
`
const WrapSign = styled.div`
  max-width: 330px;
  width: 100%;
`
const Annuity = props => {
  const {productList = []} = props

  return (
    <Layout>
      <GoBack onClick={() => props.history.push(path.planningPath())}>
        <FontAwesomeIcon icon={['fas', 'chevron-left']} />
        ประกันบำนาญ
      </GoBack>

      <SelectionSliderBar>
        <InsuranceType>
          <FontAwesomeIcon icon={['fas', 'man-with-cane']} />
          <TopicType>ประกันบำนาญ</TopicType>
          <DescriptionType>
            ลดภาษีได้สูงสุด{' '}
            {toCurrency(props.maxAnnuityInsuranceReducedTax, {
              prefix: '',
            })}{' '}
            บาท เมื่อซื้อประกันบำนาญเป็นเงิน{' '}
            {toCurrency(props.maxAnnuityInsuranceInvest, {prefix: ''})} บาท
            พร้อมมีเงินใช้ยามเกษียณ
          </DescriptionType>
        </InsuranceType>

        <Budget onClick={props.onTooltipBudget}>
          งบประมาณที่จะใช้ซื้อประกัน
          <FontAwesomeIcon
            onClick={props.tooltipReduceTax}
            icon={['fas', 'info-circle']}
          />
        </Budget>

        <CustomCurrency
          answerName="planning_deduct_pension_insurance"
          withPrefix
          onAfterBlur={props.fetchProductList}
        />
        <NormalSlider
          answerName="planning_deduct_pension_insurance"
          onAfterBlur={props.fetchProductList}
        />
      </SelectionSliderBar>

      {productList.map((product, index) => {
        if (index < 5) {
          const payPeriod =
            product.paidPremiumType === 'period'
              ? `จ่าย ${toCurrency(product.payPeriod, {prefix: ''})} ปี`
              : `จ่ายถึงอายุ ${toCurrency(
                  product.payPeriod
                    ? product.payPeriod
                    : product.minAgeAnnuity - 1,
                  {prefix: ''},
                )} ปี`
          return (
            <Fragment key={`Annuity-${index}`}>
              {index === 0 && (
                <WrapSign>
                  <SuggestSign>แนะนำ</SuggestSign>
                </WrapSign>
              )}
              <Card
                key={`Annuity-${index}`}
                suggest={index === 0}
                onClick={() =>
                  props.history.push({
                    pathname: path.productDetailPath('annuity', product.id),
                    state: {suggest: index === 0},
                  })
                }>
                <Top>
                  <Img src={product.companyOfficialLogoUrl || defaultLogo} />
                  <WrapText>
                    <Name>{product.name}</Name>
                    <Symbol>{product.companyName}</Symbol>
                  </WrapText>
                  <Wrap>
                    <Shield src={shield} />
                    <Point>{numeral(product.score).format('0[.]0')}</Point>
                  </Wrap>
                </Top>
                <Mid>
                  <InsuranceText>
                    เงินที่ต้องจ่ายต่อปี (เบี้ยประกัน)
                  </InsuranceText>
                  <InsuranceValue>
                    <MoneySymbol>฿ </MoneySymbol>
                    {toCurrency(product.premium, {prefix: ''})}
                  </InsuranceValue>
                  <SmallText>{payPeriod}</SmallText>
                </Mid>
                <Footer>
                  <Row>
                    <Label>
                      <Icon icon={['fas', 'shield-alt']} />
                      ได้เงินคืนหลังเกษียณต่อปี
                    </Label>
                    <MoneySymbol>
                      ฿ {toCurrency(product.annuityRefundPerYear, {prefix: ''})}
                    </MoneySymbol>
                  </Row>
                  <Row>
                    <Label>
                      <Icon icon={['fas', 'undo-alt']} />
                      ได้เงินคืนตั้งแต่อายุ
                    </Label>
                    <Value>
                      {product.minAgeAnnuity} - {product.maxAgeAnnuity} ปี
                    </Value>
                  </Row>
                  <Row>
                    <Label>
                      <Icon icon={['fas', 'hand-holding-usd']} />
                      ได้รับเงินเมื่อเสียชีวิต
                    </Label>
                    <Value>
                      เริ่มที่ ฿ {toCurrency(product.sumInsured, {prefix: ''})}
                    </Value>
                  </Row>
                  <Row>
                    <Label>
                      <Icon icon={['fas', 'calculator']} />
                      ลดภาษีปีนี้ได้
                    </Label>
                    <Value>฿{toCurrency(product.premium, {prefix: ''})}</Value>
                  </Row>
                </Footer>
              </Card>
            </Fragment>
          )
        }
      })}

      <TooltipBudgetModal
        isShowModal={props.tooltipBudget}
        setIsShowModal={props.setTooltipBudget}
      />
    </Layout>
  )
}

const enhancer = compose(
  withAnswers('noontax_config_web_tax_planning', {
    age: 'age.value',
    gender: 'gender.value',
    additoinalInsurancePension: 'planning_deduct_pension_insurance',
    maxAnnuityInsuranceInvest: 'summary_data.value.maxAnnuityInsuranceInvest',
    maxAnnuityInsuranceReducedTax:
      'summary_data.value.maxAnnuityInsuranceReducedTax',
  }),
  withState('productList', 'setProductList', []),
  withState('tooltipBudget', 'setTooltipBudget', false),
  withHandlers({
    onTooltipBudget: props => () => {
      props.setTooltipBudget(true)
    },
    fetchProductList: props => async () => {
      const response = await itaxApi.get(
        '/partner/api/v1/life_insurance_policies/top',
        {
          premium: props.additoinalInsurancePension
            ? props.additoinalInsurancePension.value
            : 0,
          age: props.age,
          gender: props.gender,
          insurance_type: 'annuity',
          weight_type: 1,
        },
      )
      props.setProductList(response.data.data.lifeInsurancePolicies)
    },
  }),
  lifecycle({
    async componentDidMount() {
      const names = ['planning_deduct_pension_insurance']
      // await spidusStore.loadAnswers('noontax_config_web_tax_planning', ...names)
      this.props.fetchProductList()
    },
  }),
)

export default enhancer(Annuity)
